/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React, {Component, Fragment} from 'react'
import {connect} from "react-redux";
import autobind from 'autobind-decorator';
import {Col, Container, Row} from 'react-bootstrap';

import {ErrorDisplay} from '../ErrorDisplay';
import {Conditional} from "../../Conditional";
import {ConfirmationDialog} from "../ConfirmationDialog";
import {CLEAR_ERRORS, SET_UNKNOWN_ERROR} from "../../../Redux/Actions/Types";
import {Glyphicon} from "../GlyphIcon";

export const StreamBankErrorDisplayEnhance = ((ComposedComponent) => {
    class StreamBankErrorDisplayEnhance extends Component {
        componentDidCatch(error, info) {
            this.props.dispatch({type: SET_UNKNOWN_ERROR, error: {
                Code: 600, //TODO: 600 code because this is a client error? I know it's not http, but I figured we'd just take an unused range and go with it to look similar?
                Message: error?.message,
                Title: error?.name,
                StackTrace: info?.componentStack
            }});
        }

        closeError() {
            this.props.dispatch({type: CLEAR_ERRORS});
        }

        render() {
            const {confirm, error, unknownError} = this.props;

            return <Fragment>
                <ErrorDisplay
                    Display={error !== null}
                    Error={error}
                    Close={_ => this.closeError()}
                />
                <ConfirmationDialog
                    Title={confirm?.title}
                    Body={
                        <React.Fragment>
                            <Row>
                                <Col xs={12}>
                                    {confirm?.message}
                                </Col>
                            </Row>
                        </React.Fragment>
                    }
                    CancelButtonMessage={confirm?.cancelButtonMessage}
                    OnClose={null}
                    ConfirmationButtonMessage={confirm?.okButtonMessage ?? "OK"}
                    Display={confirm !== null}
                    OnConfirm={() => this.props.dispatch({type: CLEAR_ERRORS})}
                />
                <Conditional Condition={!unknownError}>
                    <ComposedComponent
                        {...this.props}
                    />
                </Conditional>
                <Conditional Condition={unknownError}>
                    <Container className="sb-unknown-error-display">
                        <Row>
                            <Col xs={12}>
                                <Glyphicon glyph="exclamation-sign"/>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                An unhandled error has occurred.
                            </Col>
                        </Row>
                    </Container>
                </Conditional>
            </Fragment>;
        }
    }

    function mapStateToProps(state) {
        const {errorState} = state;
        return {
            error: errorState.error,
            unknownError: errorState.unknownError,
            confirm: errorState.confirm
        }
    }

    return connect(mapStateToProps)(StreamBankErrorDisplayEnhance);
});
